import { text, type Localized } from '../shared/content';
export const localizedErrors: Record<string, Localized> = Object.create(null);
define('PAYLOAD_TOO_LARGE', text('This request is too large. Use a smaller image or shorter text.', '内容超过大小限制，请缩小图片或缩短文字。', '內容超過大小限制，請縮小圖片或縮短文字。', 'La solicitud es demasiado grande. Reduce la imagen o el texto.'));
define('CONTENT_TYPE', text('Use a supported request format.', '请使用支持的内容格式。', '請使用支援的內容格式。', 'Usa un formato de solicitud compatible.'));
// The normal sign-in screen can retry without losing the entered account.
define(
  'ADULT_CONFIRMATION_REQUIRED',
  text(
    'Confirm that you are 18 or older before creating an account.',
    '创建账号前，请确认你已年满18岁。',
    '建立帳號前，請確認你已年滿18歲。',
    'Confirma que tienes 18 años o más antes de crear una cuenta.',
  ),
);
define(
  'AUTH_PATH',
  text(
    'This account link is invalid. Open the game and try again.',
    '账号链接格式不正确，请从游戏页面重新操作。',
    '帳號連結格式不正確，請從遊戲頁面重新操作。',
    'El enlace de acceso no es válido. Abre el juego y vuelve a intentarlo.',
  ),
);
function define(codes: string, copy: Localized) {
  for (const code of codes.split(' ')) localizedErrors[code] = copy;
}
define(
  'AUTH_BUSY',
  text(
    'Sign-in is busy. Please wait a moment and try again.',
    '登录请求较多，请稍等片刻再试。',
    '登入請求較多，請稍候再試。',
    'Hay muchas solicitudes. Espera un momento y vuelve a intentarlo.',
  ),
);
define(
  'CHAT_SCENE',
  text(
    'Reconnect to this scene before sending. Your draft was kept.',
    '请等待当前场景重新连接后再发送，草稿已保留。',
    '請等待目前場景重新連線後再傳送，草稿已保留。',
    'Vuelve a conectar con esta escena antes de enviar. Tu borrador se conserva.',
  ),
);
define(
  'COMMAND_BUSY',
  text(
    'Let the current actions finish, then try again.',
    '请等待当前操作完成后重试。',
    '請等待目前操作完成後重試。',
    'Espera a que terminen las acciones actuales e inténtalo de nuevo.',
  ),
);
define(
  'UNAUTHORIZED',
  text(
    'Please sign in to continue.',
    '请先登录再继续。',
    '請先登入再繼續。',
    'Inicia sesión para continuar.',
  ),
);
define(
  'NO_CHARACTER CHARACTER',
  text(
    'Create your city character first.',
    '请先创建你的城市角色。',
    '請先建立你的城市角色。',
    'Primero crea tu personaje.',
  ),
);
define(
  'INVALID_EMAIL_OR_PASSWORD INVALID_PASSWORD',
  text(
    'The email or password is incorrect.',
    '邮箱或密码不正确。',
    '信箱或密碼不正確。',
    'El correo o la contraseña no son correctos.',
  ),
);
define(
  'USER_ALREADY_EXISTS USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL',
  text(
    'This email is already registered. Sign in or use account recovery.',
    '这个邮箱已经注册，请登录或找回账号。',
    '這個信箱已註冊，請登入或找回帳號。',
    'Este correo ya está registrado. Inicia sesión o recupera tu cuenta.',
  ),
);
define(
  'PASSWORD_TOO_SHORT PASSWORD_TOO_LONG VALIDATION',
  text(
    'Check the entered values and password requirements.',
    '请检查填写内容和密码要求。',
    '請檢查填寫內容和密碼要求。',
    'Revisa los datos y los requisitos de la contraseña.',
  ),
);
define(
  'SESSION_CHANGED',
  text(
    'The signed-in account changed. Reload before continuing.',
    '登录账号已切换，请刷新后继续。',
    '登入帳號已切換，請重新整理後繼續。',
    'La cuenta ha cambiado. Recarga para continuar.',
  ),
);
define(
  'NETWORK',
  text(
    'Connection interrupted. Confirmed progress is saved; please try again.',
    '连接中断，已确认的进度会保留，请稍后重试。',
    '連線中斷，已確認的進度會保留，請稍後重試。',
    'Conexión interrumpida. El progreso confirmado está guardado; inténtalo de nuevo.',
  ),
);
define(
  'ORIGIN',
  text(
    'Open the game from its official address and reload.',
    '请从游戏的正式地址打开并刷新。',
    '請從遊戲的正式網址開啟並重新整理。',
    'Abre el juego desde su dirección oficial y recarga.',
  ),
);
define(
  'CAPACITY RATE_LIMIT BUSY TRANSLATION_BUSY',
  text(
    'The service is busy. Please try again shortly.',
    '当前服务繁忙，请稍后重试。',
    '目前服務忙碌，請稍後重試。',
    'El servicio está ocupado. Inténtalo en un momento.',
  ),
);
define(
  'REGISTRATIONS_PAUSED',
  text(
    'New registrations are temporarily paused for platform review.',
    '平台审核期间暂缓新注册，请稍后再来。',
    '平台審核期間暫緩新註冊，請稍後再來。',
    'Los nuevos registros están pausados temporalmente para revisión.',
  ),
);
define(
  'EMAIL_UNAVAILABLE',
  text(
    'Email delivery is temporarily unavailable. Please try later.',
    '邮件服务暂不可用，请稍后重试。',
    '郵件服務暫時無法使用，請稍後重試。',
    'El correo no está disponible temporalmente. Inténtalo más tarde.',
  ),
);
define(
  'ACCOUNT_RESTRICTED',
  text(
    'This account is temporarily restricted. Use account support to request a review.',
    '账号暂时受限，可通过账号申诉申请复核。',
    '帳號暫時受限，可透過帳號申訴申請複核。',
    'Esta cuenta tiene una restricción temporal. Solicita una revisión desde soporte de cuenta.',
  ),
);
define(
  'EARNED_FUNDS',
  text(
    'Player cafés use earned cash. Starter grants are for system services.',
    '玩家咖啡店使用劳动等玩法所得现金；安家补助用于系统服务。',
    '玩家咖啡店使用勞動等玩法所得現金；安家補助用於系統服務。',
    'Las cafeterías de jugadores aceptan efectivo ganado. Las ayudas iniciales son para servicios del sistema.',
  ),
);
define(
  'FUNDS',
  text(
    'Not enough cash. Try a shift or a free activity.',
    '现金不足，可以先工作或选择免费活动。',
    '現金不足，可以先工作或選擇免費活動。',
    'No tienes suficiente efectivo. Trabaja o prueba una actividad gratuita.',
  ),
);
define(
  'NEEDS',
  text(
    'Eat something or rest for free at home first.',
    '先吃点东西，或回家免费休息。',
    '先吃點東西，或回家免費休息。',
    'Come algo o descansa gratis en casa primero.',
  ),
);
define(
  'DAILY_LIMIT',
  text(
    'Today’s allowance is used. Try another part of city life.',
    '今日额度已用完，试试城市生活的其他部分。',
    '今日額度已用完，試試城市生活的其他部分。',
    'Has usado la cuota de hoy. Prueba otra parte de la vida urbana.',
  ),
);
define(
  'COOLDOWN EARLY',
  text(
    'This action is not ready yet. Wait a little before trying again.',
    '这项操作还没准备好，请稍等再试。',
    '這項操作還沒準備好，請稍等再試。',
    'Esta acción aún no está lista. Espera un poco.',
  ),
);
define(
  'LOCATION DESTINATION PATH ROOM_ZONE',
  text(
    'Visit the correct, reachable place before continuing.',
    '请先前往可抵达的对应地点。',
    '請先前往可抵達的對應地點。',
    'Ve primero al lugar correcto y accesible.',
  ),
);
define(
  'TRAVEL TRAVELING',
  text(
    'Finish the current journey before choosing another action.',
    '请先完成当前行程，再选择其他操作。',
    '請先完成目前行程，再選擇其他操作。',
    'Termina el trayecto actual antes de elegir otra acción.',
  ),
);
define(
  'WORKING',
  text(
    'Finish or cancel your current shift first.',
    '请先完成或取消当前工作。',
    '請先完成或取消目前工作。',
    'Termina o cancela tu turno actual primero.',
  ),
);
define(
  'WORK',
  text(
    'This shift has ended or is no longer available.',
    '这班工作已结束或不再可用。',
    '這班工作已結束或不再可用。',
    'Este turno ha terminado o ya no está disponible.',
  ),
);
define(
  'WORK_EXPIRED',
  text(
    'This shift expired after 24 hours. Cancel it and start a new one.',
    '这班工作已超过 24 小时，请取消后开始新工作。',
    '這班工作已超過 24 小時，請取消後開始新工作。',
    'Han pasado 24 horas. Cancela este turno y empieza otro.',
  ),
);
define(
  'GOAL',
  text(
    'There is still a little more to do for this chapter.',
    '这个目标还差一点，继续体验吧。',
    '這個目標還差一點，繼續體驗吧。',
    'Todavía queda un poco por hacer en este capítulo.',
  ),
);
define(
  'CLAIMED COMPLETE',
  text(
    'This goal or project is already complete.',
    '这项目标或公共项目已经完成。',
    '這項目標或公共專案已經完成。',
    'Este objetivo o proyecto ya está completado.',
  ),
);
define(
  'STOCK',
  text(
    'The café needs more supplies, or its storage is full.',
    '咖啡店需要补货，或库存空间已满。',
    '咖啡店需要補貨，或庫存空間已滿。',
    'La cafetería necesita suministros o su almacén está lleno.',
  ),
);
define(
  'SELF SELF_TRADE',
  text(
    'Choose another resident. Use your kitchen for your own meals.',
    '请选择其他居民；自己用餐可以使用厨房。',
    '請選擇其他居民；自己用餐可以使用廚房。',
    'Elige a otro vecino. Usa tu cocina para tus propias comidas.',
  ),
);
define(
  'OVERLAP BOUNDS',
  text(
    'Choose a clear spot inside the room and leave the bed accessible.',
    '请在房间内选择空位，并为床留出空间。',
    '請在房間內選擇空位，並為床留出空間。',
    'Elige un sitio libre dentro de la habitación y deja espacio para la cama.',
  ),
);
define(
  'SLOTS',
  text(
    'This room is full. Move existing furniture or upgrade your home.',
    '房间已满，可以移动现有家具或升级住所。',
    '房間已滿，可以移動現有家具或升級住所。',
    'La habitación está llena. Reubica muebles o amplía tu hogar.',
  ),
);
define(
  'OWNED',
  text(
    'You already own this item. Place it from your collection.',
    '你已经拥有这件家具，可以直接摆放。',
    '你已經擁有這件家具，可以直接擺放。',
    'Ya tienes este mueble. Colócalo desde tu colección.',
  ),
);
define(
  'OWNERSHIP ITEM',
  text(
    'Choose furniture you own.',
    '请选择已拥有的家具。',
    '請選擇已擁有的家具。',
    'Elige un mueble que tengas.',
  ),
);
define(
  'HOME',
  text(
    'Choose the next home upgrade.',
    '请选择下一档住所升级。',
    '請選擇下一級住所升級。',
    'Elige la siguiente mejora de vivienda.',
  ),
);
define(
  'SHOP',
  text(
    'Open your café first, or refresh the café list.',
    '请先开设咖啡店，或刷新店铺列表。',
    '請先開設咖啡店，或重新整理店鋪清單。',
    'Primero abre tu cafetería o actualiza la lista.',
  ),
);
define(
  'PLAYER NPC',
  text(
    'This neighbor is unavailable. Please refresh.',
    '这位邻居暂不可用，请刷新。',
    '這位鄰居暫時無法互動，請重新整理。',
    'Este vecino no está disponible. Actualiza la página.',
  ),
);
define(
  'POST SHARE NOT_FOUND',
  text(
    'This content is unavailable, private or withdrawn.',
    '内容已失效、设为私密或被撤回。',
    '內容已失效、設為私人或已撤回。',
    'Este contenido no está disponible, es privado o se ha retirado.',
  ),
);
define(
  'BLOCKED HOME_PRIVATE',
  text(
    'Your current privacy settings do not allow this interaction.',
    '当前隐私设置不允许这项互动。',
    '目前隱私設定不允許這項互動。',
    'La configuración de privacidad no permite esta interacción.',
  ),
);
define(
  'FRIEND',
  text(
    'Accept a friendship invitation before this interaction.',
    '请先成为已接受邀请的好友。',
    '請先成為已接受邀請的好友。',
    'Acepta primero una invitación de amistad.',
  ),
);
define(
  'FRIEND_LIMIT',
  text(
    'The friend or invitation limit has been reached. Review existing invitations first.',
    '好友或邀请数量已达上限，请先处理已有邀请。',
    '好友或邀請數量已達上限，請先處理已有邀請。',
    'Se alcanzó el límite de amigos o invitaciones. Revisa las pendientes.',
  ),
);
define(
  'OFFLINE',
  text(
    'Your friend is offline. You can visit their permitted home or cooperate asynchronously.',
    '好友暂不在线，仍可按权限参观住所或异步合作。',
    '好友暫時不在線，仍可依權限參觀住所或非同步合作。',
    'Tu amigo está desconectado. Puedes visitar su hogar si lo permite o colaborar más tarde.',
  ),
);
define(
  'COOP COOP_EXPIRED',
  text(
    'This supper is unavailable or expired. Start another plan.',
    '这次晚餐计划已失效或过期，可以开始新计划。',
    '這次晚餐計畫已失效或過期，可以開始新計畫。',
    'Esta cena no está disponible o ha caducado. Empieza otra.',
  ),
);
define(
  'COOP_ACTIVE',
  text(
    'Finish your current supper plan first.',
    '请先完成当前晚餐计划。',
    '請先完成目前晚餐計畫。',
    'Termina primero tu cena actual.',
  ),
);
define(
  'COOP_INVITATIONS',
  text(
    'This neighbor already has enough pending supper invitations.',
    '这位邻居待处理的合作邀请已满。',
    '這位鄰居待處理的合作邀請已滿。',
    'Este vecino tiene demasiadas invitaciones pendientes.',
  ),
);
define(
  'COOP_ROLE COOP_STEP',
  text(
    'Follow your own supper steps in order. If your partner is away, the host can request NPC help.',
    '请按顺序完成自己的步骤；伙伴不在时，发起人可以请 NPC 接替。',
    '請依序完成自己的步驟；夥伴不在時，發起人可以請 NPC 接替。',
    'Completa tus pasos en orden. Si tu compañero está ausente, el organizador puede pedir ayuda NPC.',
  ),
);
define(
  'ELECTION_PAUSED',
  text(
    'Elections are temporarily paused. City life continues.',
    '选举暂时暂停，日常城市生活继续。',
    '選舉暫時暫停，日常城市生活繼續。',
    'Las elecciones están en pausa. La vida de la ciudad continúa.',
  ),
);
define(
  'ELECTION_PHASE',
  text(
    'This election stage has closed. Check the current city schedule.',
    '当前选举阶段已关闭，请查看最新日程。',
    '目前選舉階段已關閉，請查看最新日程。',
    'Esta fase electoral ha cerrado. Consulta el calendario actual.',
  ),
);
define(
  'ELIGIBILITY',
  text(
    'Check verified email, 72-hour residency, active dates and story goals. The city needs 30 eligible residents.',
    '请检查邮箱验证、72 小时居住、活跃日期和新手目标；城市需 30 位合格居民。',
    '請檢查信箱驗證、72 小時居住、活躍日期和新手目標；城市需 30 位合格居民。',
    'Comprueba correo, 72 h de residencia, días activos y objetivos. Se necesitan 30 electores elegibles.',
  ),
);
define(
  'DISTRICT',
  text(
    'Run for council in your home district. Travel does not change your voting district.',
    '议员参选需在居住选区，旅行不会改变选区。',
    '議員參選需在居住選區，旅行不會改變選區。',
    'Preséntate a concejal en tu distrito de residencia. Viajar no cambia tu distrito.',
  ),
);
define(
  'CANDIDATE',
  text(
    'The candidate is unavailable or you already registered. Refresh the candidate list.',
    '候选人暂不可用，或你已报名，请刷新名单。',
    '候選人暫時無法選擇，或你已報名，請重新整理名單。',
    'El candidato no está disponible o ya te has inscrito. Actualiza la lista.',
  ),
);
define(
  'TERM_LIMIT',
  text(
    'Two successive terms require a different officeholder or a break of at least 21 days.',
    '连续两任后，需要他人接任或间隔至少 21 天。',
    '連續兩任後，需要他人接任或間隔至少 21 天。',
    'Tras dos mandatos seguidos debe asumir otra persona o pasar al menos 21 días.',
  ),
);
define(
  'OFFICE',
  text(
    'This office or civic action is not available to your current character. Check election and role rules.',
    '当前角色不符合这项公职操作的要求，请查看参选和权限规则。',
    '目前角色不符合這項公職操作的要求，請查看參選及權限規則。',
    'Tu personaje no puede realizar esta acción cívica. Consulta las reglas electorales y del cargo.',
  ),
);
define(
  'PROPOSAL POLICY',
  text(
    'The proposal is expired or unavailable. Choose a permitted policy level.',
    '提案已过期或不可用，请选择允许的政策档位。',
    '提案已過期或無法操作，請選擇允許的政策級別。',
    'La propuesta ha caducado o no está disponible. Elige un nivel de política permitido.',
  ),
);
define(
  'PROPOSAL_QUORUM',
  text(
    'Two current councilors must approve. A predecessor’s vote cannot be inherited.',
    '需要两名现任议员批准，不能继承前任的表决。',
    '需要兩名現任議員批准，不能繼承前任的表決。',
    'Deben aprobar dos concejales actuales. No se hereda el voto de un predecesor.',
  ),
);
define(
  'REPORT_LIMIT',
  text(
    'Five reports per UTC day. Existing reports remain queued for review.',
    '每个 UTC 日最多提交五次举报，已有举报会继续等待审核。',
    '每個 UTC 日最多提交五次檢舉，已有檢舉會繼續等待審核。',
    'Máximo cinco denuncias por día UTC. Las existentes siguen pendientes de revisión.',
  ),
);
define(
  'REPORT_SELF',
  text(
    'You can edit or delete your own post.',
    '自己的帖子可以直接编辑或删除。',
    '自己的貼文可以直接編輯或刪除。',
    'Puedes editar o eliminar tu propia publicación.',
  ),
);
define(
  'REPORT',
  text(
    'This report is unavailable or was already reviewed.',
    '这条举报不可用或已经处理。',
    '這則檢舉無法操作或已處理。',
    'Esta denuncia no está disponible o ya se ha revisado.',
  ),
);
define(
  'TRANSLATION_BUDGET TRANSLATION_PROVIDER',
  text(
    'Translation is temporarily unavailable. The original message is shown.',
    '翻译暂不可用，已显示原文。',
    '翻譯暫時無法使用，已顯示原文。',
    'La traducción no está disponible. Se muestra el original.',
  ),
);
define(
  'ADMIN ADMIN_ACTION ADMIN_TARGET FLAG AD_DATES',
  text(
    'This platform operation is not permitted or needs valid settings. Elected offices do not grant administrator access.',
    '这项平台操作无权限或配置不正确；游戏内公职不提供管理员权限。',
    '這項平台操作無權限或設定不正確；遊戲內公職不提供管理員權限。',
    'No se permite esta operación o requiere una configuración válida. Un cargo del juego no concede acceso administrativo.',
  ),
);
define(
  'DISABLED',
  text(
    'This feature is temporarily paused. Other city activities remain available.',
    '这项功能暂时暂停，可以继续体验其他城市活动。',
    '這項功能暫時暫停，可以繼續體驗其他城市活動。',
    'Esta función está en pausa. Puedes seguir con otras actividades.',
  ),
);
define(
  'IDEMPOTENCY CONFLICT',
  text(
    'This action was already handled or changed. Refresh before continuing.',
    '这项操作已经处理或状态已变化，请刷新后继续。',
    '這項操作已處理或狀態已變更，請重新整理後繼續。',
    'Esta acción ya se ha procesado o ha cambiado. Actualiza para continuar.',
  ),
);
define(
  'ROOM_AUTH',
  text(
    'The scene ticket expired. Reconnecting will request a fresh one.',
    '场景票据已过期，重新连接时会获取新票据。',
    '場景票據已過期，重新連線時會取得新票據。',
    'El acceso a la escena ha caducado. La reconexión solicitará otro.',
  ),
);
define(
  'AMOUNT BALANCE_LIMIT LEDGER WALLET COMMAND INTERNAL',
  text(
    'The action could not be completed. Refresh and check your saved progress before retrying.',
    '操作未能完成，请刷新并检查已保存的进度后重试。',
    '操作未能完成，請重新整理並檢查已儲存的進度後重試。',
    'No se pudo completar la acción. Actualiza y comprueba el progreso guardado antes de repetir.',
  ),
);

define(
  'APPEAL APPEAL_REVIEWED APPEAL_LIMIT',
  text(
    'Check your current restriction and appeal status. One open appeal is allowed, with at most three submissions per thirty days.',
    '请检查当前限制和申诉状态。可有一条待处理申诉，每三十天最多提交三次。',
    '請檢查目前限制與申訴狀態。可有一則待處理申訴，每三十天最多提交三次。',
    'Comprueba la restricción y la apelación actual. Se permite una abierta y hasta tres cada treinta días.',
  ),
);
define(
  'SHARE_LIMIT',
  text(
    'Thirty active cards are allowed. Withdraw an old link before creating another.',
    '最多保留三十张有效分享卡，请先撤回旧链接。',
    '最多保留三十張有效分享卡，請先撤回舊連結。',
    'Puedes tener treinta tarjetas activas. Retira un enlace antes de crear otro.',
  ),
);

define(
  'BLOCK_LIMIT',
  text(
    'Your blocked list is full. Review it in settings before blocking another resident.',
    '屏蔽列表已满，请先在设置中整理。',
    '封鎖清單已滿，請先在設定中整理。',
    'Tu lista de bloqueos está llena. Revísala en ajustes antes de añadir otro vecino.',
  ),
);

define(
  'SHOP_CITY',
  text(
    'Choose a café in your current city.',
    '请选择当前城市的小店。',
    '請選擇目前城市的小店。',
    'Elige una cafetería de tu ciudad actual.',
  ),
);
define(
  'SHOP_LOCATION',
  text(
    'Go to the café and finish your journey before buying from a player’s shop.',
    '请先前往咖啡店，抵达后再到玩家小店消费。',
    '請先前往咖啡店，抵達後再到玩家小店消費。',
    'Ve a la cafetería y termina el trayecto antes de comprar en una tienda de un jugador.',
  ),
);
define(
  'SHOP_UNAVAILABLE',
  text(
    'This café is unavailable. Choose another shop.',
    '这家小店暂不可访问，请选择其他店铺。',
    '這家小店暫時無法存取，請選擇其他店鋪。',
    'Esta cafetería no está disponible. Elige otra tienda.',
  ),
);
define(
  'SHOP_CURSOR',
  text(
    'Refresh the café directory after changing filters.',
    '筛选条件已变化，请重新搜索小店。',
    '篩選條件已變更，請重新搜尋小店。',
    'Actualiza el directorio después de cambiar los filtros.',
  ),
);

define(
  'AD_SCHEDULE_CONFLICT',
  text(
    'This placement already has an approved campaign during that time. Choose a different schedule or pause the existing campaign.',
    '该广告位在此时段已有获批投放，请调整排期或先暂停原投放。',
    '該廣告位在此時段已有核准投放，請調整排期或先暫停原投放。',
    'Este espacio ya tiene una campaña aprobada en ese período. Cambia el horario o pausa la campaña existente.',
  ),
);
